__webpack_require__.p = "https://sandbox.jbeprojetos.com.br/";